"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitATPlusSelfClassificationButton = exports.SubmitSelfClassificationButton = exports.SUBMIT_SELF_CLASSIFICATION_BUTTON_TEST_ID = void 0;
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const react_1 = __importDefault(require("react"));
const useGetUpdatePayDataFeedback_1 = require("../../../../components/HourlyBreakdown/SelfClassification/FeedbackModal/hooks/useGetUpdatePayDataFeedback");
const FeedbackModalContent_web_1 = require("./FeedbackModalContent.web");
const logger_1 = require("../../../../logger");
const contexts_1 = require("../../../../contexts");
exports.SUBMIT_SELF_CLASSIFICATION_BUTTON_TEST_ID = 'submit-self-classification-button';
const SubmitSelfClassificationButton = (props) => {
    const feedback = (0, useGetUpdatePayDataFeedback_1.useGetUpdatePayDataFeedback)(props);
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const emitLog = () => {
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.SELF_CLASSIFICATION_SUBMIT_UPDATE_PAYDATA_CLICK.COUNT,
            dimensions
        });
    };
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: (0, FeedbackModalContent_web_1.renderFeedbackModalContent)({
            feedback
        }), shouldCloseOnClickOutside: false }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { dataTestId: exports.SUBMIT_SELF_CLASSIFICATION_BUTTON_TEST_ID, disabled: props.isSubmitButtonDisabled, onClick: () => {
                open();
                emitLog();
                props.useUpdatePayDataResponse.updatePayData(props.updatePayDataRequest.payDataItems);
            }, variant: Button_1.ButtonVariant.Primary }, "Submit")))));
};
exports.SubmitSelfClassificationButton = SubmitSelfClassificationButton;
const SubmitATPlusSelfClassificationButton = (props) => {
    const feedback = (0, useGetUpdatePayDataFeedback_1.useGetUpdatePayDataFeedbackATPlus)(props);
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const emitLog = () => {
        logger_1.logger.emitCountMetric({
            metricName: props.isUpdateSelfClassification
                ? logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_SUBMIT_EDIT_PAYCODE_CLICK.COUNT
                : logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_SUBMIT_ADD_PAYCODE_CLICK.COUNT,
            dimensions
        });
    };
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: (0, FeedbackModalContent_web_1.renderFeedbackModalContent)({
            feedback
        }), shouldCloseOnClickOutside: false }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { dataTestId: exports.SUBMIT_SELF_CLASSIFICATION_BUTTON_TEST_ID, disabled: props.isSubmitButtonDisabled, onClick: () => {
                open();
                emitLog();
                props.isUpdateSelfClassification
                    ? props.useEditPayCodeResponse.editPayCode(props.editPayCodeRequest.updatePayCodeBody)
                    : props.useAddPayCodeResponse.addPayCode(props.addPayCodeRequest.payCodeInputBody);
            }, variant: Button_1.ButtonVariant.Primary }, "Submit")))));
};
exports.SubmitATPlusSelfClassificationButton = SubmitATPlusSelfClassificationButton;
